import React from 'react';
import './header.css';
import logoIcon from '../../Assets/Logo.svg';
import { useSelector } from 'react-redux';
import { Tooltip } from 'antd';
import publicIcon from '../../Assets/public-icon.svg';
import privateIcon from '../../Assets/Private-icon.svg';
import { ShareModal } from '../ShareModal/ShareModal';
import CompleteDocument from '../CompleteDoc/completeDoc';
import { UserAvatar } from '../Avatar/UserAvatar';
import ImportExportMenu from '../ImportExport';
import SavingSaved from '../SavingSaved/index ';
import PrintSpace from '../Print/print';

const Header = () => {
  const documentInfo = useSelector((state) => state.documentData.documentInformation);
  const userInfo = useSelector((state) => state.documentData.userInformation);
  const isReadOnly = useSelector((state) => state.documentData.isReadOnly);

  return (
    <div className="header">
      <div className="header-left">
        <img src={logoIcon} width={40} alt="Logo" />
        <div className="document-name">
          {documentInfo.name}
        </div>
        <div className="privacy-icon">
          {documentInfo?.privacyId === 2 ? (
            <Tooltip title="Private document">
              <img src={privateIcon} alt="Private document" style={{ width: '12px' }} />
            </Tooltip>
          ) : (
            <Tooltip title="Public document">
              <img src={publicIcon} alt="Public document" style={{ width: '15px' }} />
            </Tooltip>
          )}
        </div>
        <PrintSpace/>
        {
          !isReadOnly && <CompleteDocument />
        }
        {!isReadOnly && <ImportExportMenu/>}
        {!isReadOnly && <SavingSaved/>}
      </div>
      <div className="header-right">
        {documentInfo?.createBy === userInfo.userId && <ShareModal />}
        {/* <UserAvatar /> */}
        <UserAvatar />
      </div>
    </div>
  );
};

export default Header;
